class GraphContainer {
    static Namespace = "http://www.w3.org/2000/svg"; //DevSkim: ignore DS137138

    /**
     * 
     * @param {SVGElement|SVGAElement[]} object 
     */
    constructor(objects) {
        /**
         * @type {SVGAElement[]}
         */
        this._objects = objects instanceof Array ? objects : [objects];

    }

    erase() {
        this._objects.forEach(x => x.innerHTML = "");

        return this;
    }

    getObject(index) { return this._objects[index]; }

    /**
     * 
     * @param {string} name 
     * @param {string|string[]} value 
     */
    setAttribute(name, value) {
        if (value instanceof Array) {
            value = value.join(",");
            this._objects.forEach(x => x.setAttribute(name, value));
        } else
            this._objects.forEach(x => x.setAttribute(name, value));

        return this;
    }

    /**
     * 
     * @param {string} name 
     */
    removeAttribute(name) {
        this._objects.forEach(x => x.removeAttribute(name));

        return this;
    }

    /**
     * 
     * @param {string} value 
     */
    innerText(value) {
        this._objects.forEach(x => x.innerHTML = value);

        return this;
    }

    /**
     * 
     * @param {string} type
     * @param {Function} listener
     * @param {AddEventListenerOptions} options
     */
    addListener(type, listener, options = false) {
        this._objects.forEach(x => x.addEventListener(type, listener, options));

        return this;
    }

    append(...objects) {
        objects.forEach(object => {
            object = (object instanceof GraphContainer ? object : new GraphContainer(object))._objects;

            this._objects.forEach((container, i) => {
                if (!object[i]) return;

                container.appendChild(object[i]);
            });
        });

        return this;
    }

    /**
     * 
     * @param {SVGElement} target 
     */
    contains(target) { return this._objects.includes(target); }

    static createDOM(type) { return document.createElementNS(GraphContainer.Namespace, type); }
    static create(type) { return new GraphContainer(typeof (type) === "string" ? GraphContainer.createDOM(type) : type); }
}

function getOrSet() {
    if (arguments.length <= 1) throw new Error("Must include at least two arguments.");

    const [object, key, value] = arguments;

    if (arguments.length === 2) return object[key].valueOf();

    object[key] = value;

    return this;
}

function getOrSetVec() {
    if (arguments.length === 0) throw new Error("Must include at least one argument.");

    const key = arguments[0];
    const _args = Array.prototype.slice.call(arguments, 1)

    if (_args.length === 0) return this[key];
    if (_args.length >= 2) this[key].set(..._args)
    else if (_args.length === 1) this[key].copy(_args[0]);

    return this;
}

export default GraphContainer;
export { GraphContainer, getOrSet, getOrSetVec };